export default {
  getNowTime() {
    var today = new Date()
    return today
  },
  formatTime(t){
    function formatTime(time) {
      return time < 10 ? `0${time}` : `${time}`
    }
    const time = formatTime(t.getHours()) + ':' + formatTime(t.getMinutes()) + ':' + formatTime(t.getSeconds());
    // time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

    return time.toString()
  }
}